<div class="pb-0 banner-donation position-relative" *ngIf="campaign as vm">
  <img [src]="vm.imageUrl || fallback" [alt]="vm.name || 'Banner Donation Modal'" />

  <!-- Language Dropdown Button -->
  <div class="banner-lang-dropdown position-absolute top-0 start-0 ms-lg-4 mt-2">
    <don-language-selector size="desktop" (languageChange)="changeLanguage($event)"></don-language-selector>
  </div>
</div>